import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { UrlService } from './url.service';
import { LUPA_TOKEN_STORAGE,LUPA_IS_TMP_TOKEN,LUPA_VERSION_STORAGE } from '../consts/appConsts';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    token: string;
    event_token: string;
    tokenChange: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    isTmpToken:boolean;
    listenToParams = true;
    $showNamePage : BehaviorSubject<boolean> = new BehaviorSubject(false);
    
    constructor(private route: ActivatedRoute, private urlService: UrlService) {

        this.route.queryParams.subscribe(params => {
            if (!this.listenToParams) {
                return;
            }
            const token = params['token'];
            this.checkAndUpdateVersion();
            if (token) {
                this.token = token;
                this.event_token = params['event_token'];
                this.setStoredToken();
                this.removeTokenFromUrl();
                this.resetTmpToken();
            } else {
                this.getStoredToken();
                this.getStoredTmpToken();
            }
            this.tokenChange.next(this.token);
        });
    }
    checkAndUpdateVersion(){
        try{
        let version = localStorage.getItem(LUPA_VERSION_STORAGE);        
        let envVersion = environment.version;
        if(version != envVersion){
            this.clearTokenStorage();
        }
        localStorage.setItem(LUPA_VERSION_STORAGE,envVersion);
    }catch(e){
        console.log(e);
    }
    }
    setToken(token) {
        this.token = token;
        this.replaceToken(token);
    }

    setEventToken(eventToken) {
        this.event_token = eventToken;
        this.setStoredToken();
    }
    removeTokenFromUrl() {
        this.urlService.removeParamsFromUrl().subscribe(changed => {
            if (changed) {
                this.listenToParams = true;
            }
        });
    }
    clearTokenStorage() {
        localStorage.removeItem(LUPA_TOKEN_STORAGE);
    }
    private replaceToken(token) {
        this.setStoredToken();
        this.tokenChange.next(this.token);
        // this.urlService.addQueryParam('token', token);
    }
    setTmpToken(_isTmpToken:boolean):void{
        this.isTmpToken = _isTmpToken;
        if(this.isTmpToken){
            localStorage.setItem(LUPA_IS_TMP_TOKEN,'true');
        }
        else{
            this.resetTmpToken();
        }
    }
    isLoggedIn():boolean{
        return (!this.isTmpToken);
    }
    resetTmpToken():void{
        this.isTmpToken = false;
        localStorage.removeItem(LUPA_IS_TMP_TOKEN);
    }
     hasEventToken():boolean{
        if(this.event_token){
        return true;
        }
        return false;
    }

    private setStoredToken() {
        localStorage.setItem(
            LUPA_TOKEN_STORAGE,
            JSON.stringify({ token: this.token, event_token: this.event_token })
        );

    }

    private getStoredToken() {
        const stringStorageToken = localStorage.getItem(LUPA_TOKEN_STORAGE);
        if (!stringStorageToken) {
            return;
        }
        const storageToken = JSON.parse(stringStorageToken);
        this.token = storageToken.token;
        this.event_token = storageToken.event_token;
    }

    private getStoredTmpToken(){
        const stringTmpToken = localStorage.getItem(LUPA_IS_TMP_TOKEN);
        if (!stringTmpToken) {
            this.isTmpToken = false;
        }else{
            this.isTmpToken = true;
        }
       
    }


    //cookies
    private setCookie(name: string, value: string, expireDays: number, path: string = '') {
        let d:Date = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        let expires:string = `expires=${d.toUTCString()}`;
        let cpath:string = path ? `; path=${path}` : '';
        document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }

    private deleteCookie(name) {
        this.setCookie(name, '', -1);
    }

}
